export default __webpack_public_path__ + "static/media/nature.f881bc89.jpg";